import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { isMSTeams } from 'utils/MSTeams';
import { useUserFeedbackQuery } from 'Shared/FeedbackBanner/useUserFeedbackQuery';
import { getFeedbackFormLink } from 'Assistant/Chatbot/components/ChatbotFeedback/utils';
import * as S from './styles';

const HOMEPAGE_FEEDBACK_SURVEY_LINK = 'https://unmind.typeform.com/to/CkPZGfLI';

const ShareFeedback = () => {
  const { t: translate } = useTranslation('homepage');
  const theme = useTheme();
  const isTeams = isMSTeams();
  const { data } = useUserFeedbackQuery();
  const feedbackFormLink = getFeedbackFormLink(
    HOMEPAGE_FEEDBACK_SURVEY_LINK,
    data,
  );

  return (
    <S.ShareFeedbackContainer isTeams={isTeams}>
      <S.SectionHeadingTitle>
        {translate('share_feedback.section_title')}
      </S.SectionHeadingTitle>
      <S.ShareFeedbackBanner>
        <S.ShareFeedbackBannerIcon
          primaryColor={theme.colors.text.primary}
          aria-hidden="true"
        />
        <S.ShareFeedbackBannerTitle>
          {translate('share_feedback.title')}
        </S.ShareFeedbackBannerTitle>
        <S.ShareFeedbackBannerDescription>
          {translate('share_feedback.description')}
        </S.ShareFeedbackBannerDescription>
        <S.ShareFeedbackBannerButton
          variant="primary"
          onClick={() => {
            window.open(feedbackFormLink, '_blank', 'noopener,noreferrer');
          }}
          label={
            <S.ShareFeedbackBannerButtonContainer>
              {translate('share_feedback.button')}
              <S.ExternalLinkIcon aria-hidden="true" />
            </S.ShareFeedbackBannerButtonContainer>
          }
          size="small"
        />
      </S.ShareFeedbackBanner>
    </S.ShareFeedbackContainer>
  );
};

export default ShareFeedback;
